import { render, staticRenderFns } from "./infoBase.vue?vue&type=template&id=9de9c04e&scoped=true"
import script from "./infoBase.vue?vue&type=script&lang=js"
export * from "./infoBase.vue?vue&type=script&lang=js"
import style0 from "./infoBase.vue?vue&type=style&index=0&id=9de9c04e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7907ed7515d572276d45114f834f04a7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de9c04e",
  null
  
)

export default component.exports